import { render, staticRenderFns } from "./OnboardingTeamName.vue?vue&type=template&id=14dcd71e&scoped=true&"
import script from "./OnboardingTeamName.vue?vue&type=script&lang=js&"
export * from "./OnboardingTeamName.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTeamName.vue?vue&type=style&index=0&id=14dcd71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dcd71e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
